import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-400 mx-1" aria-hidden="true">
                  <i className="ri-arrow-right-s-line text-sm"></i>
                </span>
              )}
              {isLast || !item.to ? (
                <span className={isLast ? 'text-foreground-600 font-medium' : 'text-foreground-500'}>
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.to}
                  className="text-foreground-500 hover:text-primary-500 transition-colors duration-200"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}